export type Operator = "like" | "neq";

export type FilterItem = {
  id: string;
  value: {
    operator: Operator;
    term: unknown;
  };
};

type FilterInput = {
  [key: string]: {
    term: unknown;
    operator: Operator;
  };
};

export function buildFiltersArray(input: FilterInput): FilterItem[] {
  return Object.entries(input)
    .filter(
      ([, { term }]) => term !== undefined && term !== null && term !== ""
    )
    .map(([id, { operator, term }]) => ({
      id,
      value: { operator, term },
    }));
}

export function buildFiltersQueryString(filters: FilterItem[]): string {
  return filters
    .map(({ id, value }) => {
      if (
        typeof value === "object" &&
        value !== null &&
        "operator" in value &&
        "term" in value
      ) {
        return `${id}:${value.operator}=${value.term}`;
      }
      return "";
    })
    .filter(Boolean)
    .join(",");
}
